import { Box, Grid } from "@mui/material";
import MxDetailSmallCard from "@rf-l1/page/details/MxDetailCardSmall";
import MxTypography from "@rf-l1/MxTypography";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";

/**
 * PropertyProfessionalFeesCard
 *
 * Tarjeta que muestra los honorarios profesionales de la propiedad:
 * - Comisión de venta
 * - Comisión de arrendamiento
 */
const PropertyProfessionalFeesCard = () => {
  const { commission } = usePropertyDetailPage();

  if (!commission || (!commission.total && !commission.lease)) {
    return null;
  }

  return (
    <MxDetailSmallCard title="Honorarios profesionales">
      <Grid container direction="column" gap={1}>
        {commission.total && (
          <Grid item xs={12}>
            <MxTypography variant="body2" color="primary.main" fontWeight={500}>
              Comisión de venta {commission.total}%
            </MxTypography>
          </Grid>
        )}
        {commission.lease && (
          <Grid item xs={12} md={6}>
            <MxTypography variant="body2" color="primary.main" fontWeight={500}>
              Comisión de {commission.lease}
            </MxTypography>
          </Grid>
        )}
      </Grid>
    </MxDetailSmallCard>
  );
};

export default PropertyProfessionalFeesCard;
